module.exports = __webpack_public_path__ + "static/media/6.Mini Water pump.e12ce416.jpg";